<div id="profile" class="page-layout simple">
  <!-- HEADER -->
  <div class="header p-6 flex flex-col justify-center items-center md:flex-row md:justify-between md:items-end">
    <div class="user-info flex flex-col items-center md:flex-row md:items-center">
      <img
        class="profile-image avatar huge"
        src="./assets/images/avatars/profile.svg"
        *fuseIfOnDom
        [@animate]="{ value: '*', params: { delay: '50ms', scale: '0.2' } }" />
      <div class="name" *fuseIfOnDom [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
        {{ client.surname }} {{ client.name }} {{ client.companyName ? '(' + client.companyName + ')' : '' }}
      </div>
    </div>
  </div>
  <!-- / HEADER -->

  <!-- CONTENT -->
  <div class="content p-6">
    <div class="flex flex-wrap justify-around">
      <div class="w-full sm:w-4/5 md:w-2/5">
        <fuse-profile-about></fuse-profile-about>
      </div>

      <div class="w-full sm:w-4/5 md:w-2/5 flex flex-col">
        <cutting-identity-document
          *ngIf="client.type === 0 && (client.seriesDocument || client.numberDocument || client.dateOfIssueDocument)"
          [client]="client"></cutting-identity-document>
        <cutting-change-password></cutting-change-password>
        <cutting-change-email></cutting-change-email>
        <cutting-delete-account></cutting-delete-account>
      </div>
    </div>
  </div>
  <!-- / CONTENT -->
</div>
